import { isMissingField } from "../utils/mapAnalysisToBooking";

export const countCompleteFields = (
  missingFields: string[],
  allKeys: string[]
): number => allKeys.filter((key) => !isMissingField(missingFields, key)).length;

export const getTrackableFieldKeys = (
  isSeafreight: boolean,
  productCount: number,
  isFcl = false
): string[] => {
  const keys = [
    "transport.transport_type",
    "transport.booking_incoterm",
    "transport.origin_pickup_date",
    "supplier.name",
    "supplier.email",
    "supplier.phone",
    "supplier.country",
    "supplier.province",
    "supplier.city",
    "supplier.address",
  ];

  if (productCount === 0) {
    keys.push("products");
  } else {
    for (let i = 0; i < productCount; i += 1) {
      keys.push(
        `products.${i}.hs_code`,
        `products.${i}.gross_weight`,
        `products.${i}.cbm`,
        `products.${i}.value`
      );
    }
  }

  if (isSeafreight) {
    keys.push("transport.booking_type");
  }

  if (isFcl) {
    keys.push("transport.service_level");
  }

  return keys;
};
